import { render, staticRenderFns } from "./BaseCkeditor.vue?vue&type=template&id=063b166b&scoped=true&"
import script from "./BaseCkeditor.vue?vue&type=script&setup=true&lang=js&"
export * from "./BaseCkeditor.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BaseCkeditor.vue?vue&type=style&index=0&id=063b166b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063b166b",
  null
  
)

export default component.exports